export default __webpack_public_path__ + "static/media/blackRefresh.e2824ee9.svg";